package com.evoapps.evoshift.util

import androidx.compose.runtime.Composable

enum class AppPermission {
    NOTIFICATIONS,
    LOCATION,
    CAMERA
}

@Composable
expect fun rememberPermissionState(permission: AppPermission): PermissionState

interface PermissionState {
    val isGranted: Boolean
    fun launchPermissionRequest()
}
